import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TeamMemberLinkingForm from "./TeamMemberLinkingForm";

function TeamMemberLinkingFormDialog({ open, onClose, initialData = {} }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={fullScreen}
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxHeight: "90vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 2,
          pt: 2.5,
          px: 3,
          m: 0,
        }}
      >
        <Typography
          component="div"
          sx={{
            fontWeight: 700,
            fontSize: { xs: 20, sm: 24 },
            textTransform: "lowercase",
            flex: 1,
            m: 0,
          }}
        >
          {initialData?.isEdit ? "edit team member" : "link as team member"}
        </Typography>
        <IconButton 
          onClick={onClose} 
          size="small"
          edge="end"
          sx={{ 
            ml: 2,
            flexShrink: 0,
            color: "inherit",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0, overflow: "visible", "&.MuiDialogContent-root": { pt: 0 } }}>
        <TeamMemberLinkingForm
          initialData={initialData}
          onBack={onClose}
          onSuccess={onClose}
          showBackButton={false}
        />
      </DialogContent>
    </Dialog>
  );
}

export default TeamMemberLinkingFormDialog;
